import { render, staticRenderFns } from "./Jurisdiction.vue?vue&type=template&id=8f50c988&scoped=true&"
import script from "./Jurisdiction.vue?vue&type=script&lang=js&"
export * from "./Jurisdiction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f50c988",
  null
  
)

export default component.exports